import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgRatingThumbsBothFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="m15 10-4 4.81v2.69a2 2 0 0 0 2 2h3V21a2 2 0 0 0 2 2h1l4-4.76V10h-8Zm-2-3.5a2 2 0 0 0-2-2H8V3a2 2 0 0 0-2-2H5L1 5.76V14h8l4-4.81V6.5Z"
    />
  </svg>
);
export default SvgRatingThumbsBothFill;
